<template>
  <div>
    <div id="FiltreTemporel" class="form-group row mt-1">
      <label class="col-4 col-form-label">Dataset : </label>
      <div class="col-8">
        <select v-model="choixtemporelElement"
          class="form-control form-control-sm theme-bg"
          @change="updateUrl">
          <option
            v-for="item in choixtemporel"
            :key="item.key"
            class="theme-bg"
            :value="item.name">
            {{ item.value }}</option>
        </select>
      </div>
    </div>

    By <B>country</B> (top 5):
    <small>
      &nbsp;<a href @click.prevent="clearFilter('adm0_a3')">Clear</a>
      &nbsp;&nbsp;&nbsp;--> <router-link to="/misc">Misc.</router-link>
    </small>
    <country-table2 v-if="ufos.length > 0" :ufos="ufos" v-model="filters" />

    By <B>shape</B> (top 5):
    <small>
      &nbsp;<a href @click.prevent="clearFilter('shape')">Clear</a>
      &nbsp;
    </small>
    <shape-table2 v-if="ufos.length > 0" :ufos="ufos" v-model="filters" />

    By <B>day of week</B>:
    <small>
      &nbsp;<a href @click.prevent="clearFilter('weekday')">Clear</a>
      &nbsp;
    </small>
    <day-of-week-table2 v-if="ufos.length > 0" :ufos="ufos" v-model="filters" />
  </div>
</template>

<script>
import DayOfWeekTable2 from '@/components/DayOfWeekTable2.vue';
import CountryTable2 from '@/components/CountryTable2.vue';
import ShapeTable2 from '@/components/ShapeTable2.vue';
// import defaultFilters from '@/assets/misc/default-filters';
import d3 from '@/assets/d3';

export default {
  props: ['value', 'ufos'],
  data() {
    return {
      width: 300,
      height: 200,
      margin: {
        top: 20,
        right: 20,
        bottom: 20,
        left: 20,
      },
      choixtemporel: [
        { name: 'dataset3000', value: '3000 ovnis', selected: true },
        { name: 'data-2014', value: '2014' },
        { name: 'data-2013_aou_dec', value: 'aou - déc 2013' },
        { name: 'data-2013_jan_jul', value: 'jan - jul 2013' },
        { name: 'data-2012_aou_dec', value: 'aou - déc 2012' },
        { name: 'data-2012_jan_jul', value: 'jan - jul 2012' },
        { name: 'data-2011_aou_dec', value: 'aou - déc 2011' },
        { name: 'data-2011_jan_jul', value: 'jan - jul 2011' },
        { name: 'data-2010_aou_dec', value: 'aou - déc 2010' },
        { name: 'data-2010_jan_jul', value: 'jan - jul 2010' },
        { name: 'data-2009_aou_dec', value: 'aou - déc 2009' },
        { name: 'data-2009_jan_jul', value: 'jan - jul 2009' },
        { name: 'data-2008_aou_dec', value: 'aou - déc 2008' },
        { name: 'data-2008_jan_jul', value: 'jan - jul 2008' },
        { name: 'data-2007', value: '2007' },
        { name: 'data-2006', value: '2006' },
        { name: 'data-2005', value: '2005' },
        { name: 'data-2004', value: '2004' },
        { name: 'data-2003', value: '2003' },
        { name: 'data-2002', value: '2002' },
        { name: 'data-2001', value: '2001' },
        { name: 'data-2000', value: '2000' },
        { name: 'data-1999', value: '1999' },
        { name: 'data-1996_1998', value: '1996 - 1998' },
        { name: 'data-1988_1995', value: '1988 - 1995' },
        { name: 'data-1975_1987', value: '1975 - 1987' },
        { name: 'data-avant_1975', value: 'Avant 1975' },
      ],
      url: '',
      datasetURL: '',
      choixtemporelElement: 'dataset3000',
      choixformeElement: '',
      choixgeoElement: '',
    };
  },
  mounted() {
    this.initChart();
  },
  computed: {
    filters: {
      get() {
        return { ...this.value };
      },
      set(newVal) {
        this.$emit('input', newVal);
      },
    },
    outsideWidth() {
      return this.width + this.margin.left + this.margin.right;
    },
    outsideHeight() {
      return this.height + this.margin.top + this.margin.bottom;
    },
    scale() {
      const x = d3.scaleBand()
        .domain(this.ufos.map(d => d.name))
        .rangeRound([0, this.width])
        .padding(0.15);
      const y = d3.scaleLinear()
        .domain([0, Math.max(...this.ufos.map(d => d.altitude))])
        .range([this.height, 0]);
      return { x, y };
    },
  },
  methods: {
    clearFilter(filterParam) {
      const newFilters = { ...this.filters };
      newFilters[filterParam] = [];
      this.filters = newFilters;
    },
    initChart() {
      const svg = d3.select(this.$refs.chart);
      svg
        .attr('width', this.outsideWidth)
        .attr('height', this.outsideHeight);
      const g = svg.append('g')
        .attr('transform', `translate(${this.margin.left},${this.margin.top})`);
      g.append('g')
        .attr('class', 'bars');
      g.append('g')
        .attr('class', 'axis-x')
        .attr('transform', `translate(0, ${this.height})`);
      g.append('g')
        .attr('class', 'axis-y');
      this.updateChart();
    },
    updateChart() {
      /* const svg = d3.select(this.$refs.chart);
      const bars = svg.select('.bars')
        .selectAll('rect.bar')
        .data(this.ufos);
      bars
        .enter().append('rect')
        .attr('class', 'bar')
        .attr('x', d => this.scale.x(d.name))
        .attr('width', this.scale.x.bandwidth())
        .attr('y', d => this.scale.y(d.altitude))
        .attr('height', d => this.height - this.scale.y(d.altitude));
      const xAxis = svg.select('.axis-x');
      xAxis.call(d3.axisBottom(this.scale.x));
      const yAxis = svg.select('.axis-y');
      yAxis.call(d3.axisLeft(this.scale.y)); */
    },
    updateUrl() {
      this.url = `data/${this.choixtemporelElement}.geojson`;
      this.$emit('update', this.url);
    },
  },
  components: {
    DayOfWeekTable2,
    CountryTable2,
    ShapeTable2,
  },
};
</script>

<style scoped>
  svg >>> rect.bar {
    fill: rgb(36, 226, 36);
  }
  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) {
  .misc {
    max-height: calc(100vh - 56px);
    overflow: auto;
  }

  a {
    color: lightblue;
  }
}
</style>
